<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header fw-bold text-black p-2">
                        <div class="d-flex align-items-center gap-3 date-range">
                            <div class="d-flex gap-1">
                                <span class="cursor-pointer text-theme" @click="getPreviousData">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-left-icon lucide-square-arrow-left"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="m12 8-4 4 4 4"/><path d="M16 12H8"/></svg>
                                </span>
                                <span class="cursor-pointer text-theme" @click="getNextData">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-square-arrow-right-icon lucide-square-arrow-right"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M8 12h8"/><path d="m12 16 4-4-4-4"/></svg>
                                </span>
                            </div>
                            <div>
                                Available Handyman({{ this.$dateTimeFormat(currentDate, 'ddd, D MMM, YYYY')}})
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-2">
                        <table class="table hm-fs-12 hm-table-fixed mb-0 align-middle table-hover table-sm">
                            <thead>
                                <tr>
                                    <th class="bg-theme" style="width: 15%;">Name</th>
                                    <th class="bg-theme ps-0 pe-0" style="width: 85%;">
                                        <div class="row ms-0 me-0">
                                            <div v-for="(item, index) in workingHours" :key="index" class="col text-center border-1 border-start ps-0 pe-0">
                                                {{ item.display }}
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-if="handymans.length > 0"
                                    v-for="(handyman, index) in handymans"
                                    :key="index"
                                >
                                    <td class="pt-0 pb-0 pe-0">{{ handyman.name }}</td>
                                    <td class="p-0">
                                        <div
                                            class="progress rounded-0"
                                            role="progressbar"
                                            aria-valuenow="100"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                            :class="handyman.status === 'unavailable' ? 'bg-warning' : ''"
                                        >
                                            <div
                                                v-for="(segment, segmentIndex) in getTimelineSegments(handyman)"
                                                :key="segmentIndex"
                                                :tabindex="segmentIndex"
                                                class="progress-bar cursor-pointer"
                                                :class="(handyman.status === 'unavailable' ? 'bg-warning' : (segment.isBooked || handyman.projects.length > 0 ? 'bg-danger border-1 border-start border-end' : 'bg-success'))"
                                                :style="{width: `${segment.width}%`, marginLeft: segmentIndex === 0 ? `${segment.offset-1.5}%` : '0'}"
                                                data-bs-toggle="popover"
                                                data-bs-trigger="focus"
                                                data-bs-placement="top"
                                                :data-bs-content="preparePopoverContent(handyman, segment)"
                                                data-bs-html="true"
                                                @contextmenu.prevent.stop="(segment.isBooked ? handleRightClick($event, segment) : (handyman.projects.length > 0 ? handleRightClick($event, handyman.projects[0]) : ''))"
                                            >
                                                <span class="d-block">
                                                    {{ prepareRowText(handyman, segment) }}
                                                </span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-else-if="processing">
                                    <td colspan="2" class="text-center">Processing...</td>
                                </tr>
                                <tr v-else>
                                    <td colspan="2" class="text-center">No handyman found.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- right click context -->
    <vue-simple-context-menu
        element-id="handleRightClick"
        :options="rightClickOptions"
        ref="rightClickMenu"
        @option-clicked="handleRightClickMenuAction"
    >
    </vue-simple-context-menu>
</template>
<script>
import { nextTick } from 'vue';
import * as bootstrap from 'bootstrap';
import VueSimpleContextMenu from "vue-simple-context-menu";

export default {
    name: 'AvailableHandyman',
    props: {},
    components: {
        VueSimpleContextMenu
    },
    data() {
        return {
            processing: false,
            handymans: [],
            currentDate: this.$moment().format('YYYY-MM-DD'),
            rightClickOptions: [{name: 'View Detail', action: 'view_order_detail'}],
        }
    },
    mounted() {
        this.geHandymanList();
        this.initializePopovers();
    },
    computed: {
        formattedHandymen() {
            //return this.handymans.map(item => item._custom.value);
        },
        systemSettings() {
            return this.$store.getters.getSystemSettings;
        },
        workingHours() {
            const start = this.$moment(this.systemSettings.hm_working_hours_start ?? '07:00', 'HH:mm');
            const end = this.$moment(this.systemSettings.hm_working_hours_end ?? '17:00', 'HH:mm');

            const times = [];
            let currentTime = start;
            while (currentTime <= end) {
                times.push({
                    display: currentTime.format('hA'),
                    value: currentTime.format('HH:mm')
                });
                currentTime = currentTime.add(1, 'hour');
            }
            return times;
        },
        prepareRowText() {
            return (handyman, segment) => {
                if (handyman.status === 'unavailable') {
                    return 'Unavailable';
                } else if (segment.isBooked) {
                    return 'O: ' + segment.postal_code;
                } else if (handyman.projects.length > 0) {
                    return 'P: ' + handyman.projects.map(project => project.postal_code).join(', ');
                } else {
                    return '';
                }
            }
        }
    },
    methods: {
        geHandymanList() {
            let self = this;
            this.processing = true;
            axios.post('/admin/dashboard/stats?action=available_handyman', {action: 'available_handyman', date: this.currentDate})
                .then(response => {
                    // Get order summary
                    self.handymans = response.data;
                    self.processing = false;
                    self.initializePopovers();
                });
        },
         // Convert time string (HH:mm) to decimal hours
        timeToDecimal(timeStr) {
            const [hours, minutes] = timeStr.split(':').map(Number);
            return hours + (minutes / 60);
        },
        // In the getTimelineSegments method, update the calculation logic:
        getTimelineSegments(handyman) {
            const segments = [];
            const dayStart = this.$moment(this.systemSettings.hm_working_hours_start ?? '07:00', 'HH:mm').format('H');
            const dayEnd = this.$moment(this.systemSettings.hm_working_hours_end ?? '17:00', 'HH:mm').format('H');
            const totalHours = dayEnd - dayStart;

            const workStart = this.timeToDecimal(handyman.workingHours.start);
            let currentTime = workStart;

            // Sort bookings by start time
            const sortedBookings = [...handyman.bookings].sort((a, b) =>
                this.timeToDecimal(a.start) - this.timeToDecimal(b.start)
            );

            // Initial offset for non-working hours at start of day
            const initialOffset = ((workStart - dayStart) / totalHours) * 100;

            sortedBookings.forEach((booking, index) => {
                const bookingStart = this.timeToDecimal(booking.start);
                const bookingEnd = this.timeToDecimal(booking.end);

                // Add available segment before booking
                if (currentTime < bookingStart) {
                    segments.push({
                        start: currentTime,
                        end: bookingStart,
                        isBooked: false,
                        width: ((bookingStart - currentTime) / totalHours) * 100,
                        offset: index === 0 ? initialOffset : 0,
                        service_address: booking.service_address,
                        service_date: booking.service_date,
                        service_time: booking.service_time,
                        order_id: booking.order_id,
                        customer_name: booking.customer_name,
                        customer_email: booking.customer_email,
                        customer_phone: booking.customer_phone,
                        postal_code: booking.postal_code,
                        detail_url: booking.detail_url
                    });
                }

                // Add booked segment
                segments.push({
                    start: bookingStart,
                    end: bookingEnd,
                    isBooked: true,
                    width: ((bookingEnd - bookingStart) / totalHours) * 100,
                    offset: index === 0 && currentTime === workStart ? initialOffset : 0,
                    postal_code: booking.postal_code,
                    service_address: booking.service_address,
                    service_date: booking.service_date,
                    service_time: booking.service_time,
                    order_id: booking.order_id,
                    customer_name: booking.customer_name,
                    customer_email: booking.customer_email,
                    customer_phone: booking.customer_phone,
                    detail_url: booking.detail_url
                });

                currentTime = bookingEnd;
            });

            // Add remaining available time
            if (currentTime < this.timeToDecimal(handyman.workingHours.end)) {
                segments.push({
                    start: currentTime,
                    end: this.timeToDecimal(handyman.workingHours.end),
                    isBooked: false,
                    width: ((this.timeToDecimal(handyman.workingHours.end) - currentTime) / totalHours) * 100,
                    offset: segments.length === 0 ? initialOffset : 0,
                    postal_code: null,
                    service_address: null,
                    service_date: null,
                    service_time: null,
                    order_id: null,
                    customer_name: null,
                    customer_email: null,
                    customer_phone: null,
                    detail_url: null
                });
            }
            return segments;
        },
        getPreviousData() {
            this.currentDate = this.$moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD');
            this.geHandymanList();
        },
        getNextData() {
            this.currentDate = this.$moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD');
            this.geHandymanList();
        },
        initializePopovers() {
            nextTick(() => {
                // Destroy existing popovers
                const popovers = document.querySelectorAll('[data-bs-toggle="popover"]');
                popovers.forEach((popover) => {
                    const instance = bootstrap.Popover.getInstance(popover);
                    if (instance) {
                        instance.dispose();
                    }
                });

                // Initialize new popovers
                popovers.forEach((popover) => {
                    new bootstrap.Popover(popover);
                });
            });
        },
        preparePopoverContent(handyman, segment) {
            if (handyman.projects.length > 0) {
                return `<span class="d-block text-capitalize">Project: ${handyman.projects.map(project => project.project_name).join(', ')}</span>
                    <span class="d-block text-capitalize">Name: ${handyman.projects.map(project => project.customer_name).join(', ')}</span>
                    <span class="d-block">Email: ${handyman.projects.map(project => project.customer_email).join(', ')}</span>
                    <span class="d-block">Phone: ${handyman.projects.map(project => project.customer_phone).join(', ')}</span>
                    <span class="d-block text-capitalize">Address: ${handyman.projects.map(project => project.address).join(', ')}</span>
                    <span class="d-block">Postal Code: ${handyman.projects.map(project => project.postal_code).join(', ')}</span>
                    <span class="d-block">Amount: ${this.systemSettings.currency.symbol}${handyman.projects.map(project => project.final_amount).join(', ')}</span>
                    <span class="d-block text-capitalize">Status: ${handyman.projects.map(project => project.status).join(', ')}</span>
                    <span class="d-block">Start At: ${handyman.projects.map(project => this.$moment(project.start_at).format('DD/MM/YYYY')).join(', ')}</span>
                    <span class="d-block ">Ends At: ${handyman.projects.map(project => this.$moment(project.ends_at).format('DD/MM/YYYY')).join(', ')}</span>`;
            }
            else if (segment.isBooked) {
                return `<span class="d-block text-capitalize">Customer Name: ${segment.customer_name}</span>
                    <span class="d-block">Customer Email: ${segment.customer_email}</span>
                    <span class="d-block">Customer Phone: ${segment.customer_phone}</span>
                    <span class="d-block text-capitalize">Service Address: ${segment.service_address}</span>
                    <span class="d-block">Postal Code: ${segment.postal_code}</span>
                    <span class="d-block">Service Time: ${segment.service_time}</span>`;
            }
            else {
                return '';
            }
        },
        handleRightClick(event, item) {
            this.$refs.rightClickMenu.showMenu(event, item)
        },
        handleRightClickMenuAction(event) {
            let action = event.option.action;
            if (action === 'view_order_detail') {
                // Open in the same tab
                window.location.href = event.item.detail_url;
                return;
                //window.open(event.item.detail_url);
            }
        }
    }
}
</script>
<style scoped>
.progress-bar {
  transition: width 0.3s ease;
}
</style>
